import type { FC } from 'react';
import React, { createContext, useMemo } from 'react';

import { useReactionsSettings } from '@confluence/comments-hooks/entry-points/useIsReactionsEnabled.ts';

export type ReactionsContextValue = {
	isReactionsEnabled: boolean;
	isReactionsDisabledForSite?: boolean;
};

export const ReactionsContext: React.Context<ReactionsContextValue> =
	createContext<ReactionsContextValue>({
		isReactionsEnabled: false,
	});
ReactionsContext.displayName = 'ReactionsContext';

type ReactionsProviderProps = {
	contentId: string;
	children?: React.ReactNode;
};

export const ReactionsProvider: FC<ReactionsProviderProps> = ({ contentId, children }) => {
	const { isReactionsEnabled, isReactionsDisabledForSite } = useReactionsSettings(contentId);

	const reactionsContextValue = useMemo(
		() => ({ isReactionsEnabled, isReactionsDisabledForSite }),
		[isReactionsEnabled, isReactionsDisabledForSite],
	);

	return (
		<ReactionsContext.Provider value={reactionsContextValue}>{children}</ReactionsContext.Provider>
	);
};
